module.exports = __webpack_public_path__ + "img/img_quilt06@3x.3047f669.png";